import { render, staticRenderFns } from "./FillClaimCreationSection.vue?vue&type=template&id=4f513677"
import script from "./FillClaimCreationSection.vue?vue&type=script&lang=js"
export * from "./FillClaimCreationSection.vue?vue&type=script&lang=js"
import style0 from "./FillClaimCreationSection.vue?vue&type=style&index=0&id=4f513677&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports